"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectionReason = exports.ApprovalStatus = void 0;
var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["approved"] = "approved";
    ApprovalStatus["pending"] = "pending";
    ApprovalStatus["rejected"] = "rejected";
    ApprovalStatus["resubmitted"] = "resubmitted";
})(ApprovalStatus = exports.ApprovalStatus || (exports.ApprovalStatus = {}));
var RejectionReason;
(function (RejectionReason) {
    RejectionReason["image_is_cropped"] = "image_is_cropped";
    RejectionReason["image_is_unreadable"] = "image_is_unreadable";
    RejectionReason["other"] = "other";
    RejectionReason["wrong_child"] = "wrong_child";
    RejectionReason["wrong_documentation"] = "wrong_documentation";
})(RejectionReason = exports.RejectionReason || (exports.RejectionReason = {}));
